import { ReactComponent as BulletList } from 'assets/icons/icon-bulletlist.svg';

export default BulletList;
